import React, { useEffect, useState } from 'react';
import { Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import NewSideBar from '../../Components/MiniComponent/NewSideBar';
import Topnav from '../../Components/Topnav';
import WhatsAppSettings from './WhatsAppSettings';
import InboxView from './InboxView';
import CampaignsView from './CampaignsView';
import CreateCampaign from './CreateCampaign';
import CreateTemplate from './CreateTemplate';
import AnalyticsView from './AnalyticsView';
import ReminderAutomation from './ReminderAutomation';
import ContactsView from './ContactsView';
import '../../styles-wa/variables.css';

import { ConfigProvider } from '../../Context/WaConfigContext';
import { WaAuthProvider } from '../../Context/WaAuthContext';
import { ToastProvider } from '../../Context/WaToastContext';
import { NotificationProvider } from '../../Context/WaNotificationContext';

const WhatsAppRouter = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [activeTab, setActiveTab] = useState('inbox');

  useEffect(() => {
    if (location.pathname.includes('/settings')) {
      setActiveTab('settings');
    } else if (location.pathname.includes('/campaigns')) {
      setActiveTab('campaigns');
    } else if (location.pathname.includes('/analytics')) {
      setActiveTab('analytics');
    } else if (location.pathname.includes('/reminder-auto')) {
      setActiveTab('reminder-auto');
    } else if (location.pathname.includes('/contacts')) {
      setActiveTab('contacts');
    } else {
      setActiveTab('inbox');
    }
  }, [location.pathname]);

  const navLinks = [
    { id: 'inbox', name: 'Inbox', path: '/whatsapp/inbox', show: true },
    { id: 'contacts', name: 'Contacts', path: '/whatsapp/contacts', show: true },
    { id: 'campaigns', name: 'Campaigns', path: '/whatsapp/campaigns', show: true },
    { id: 'analytics', name: 'Analytics', path: '/whatsapp/analytics', show: true },
    { id: 'reminder-auto', name: 'Auto Reminder', path: '/whatsapp/reminder-auto', show: true },
    { id: 'settings', name: 'Settings', path: '/whatsapp/settings', show: true },
  ];

  // Helper function to handle sub-navigation clicks
  const handleNavClick = (path) => {
    navigate(path);
  };

  return (
    <WaAuthProvider>
      <ConfigProvider>
        <ToastProvider>
          <NotificationProvider>
            <div className="wa-module">
            <main className="flex flex-col lg:flex-row">
              <article className="sticky z-10 top-0">
                <NewSideBar />
              </article>
              <article className="flex-1 container-fluid px-0 overflow-hidden mx-auto">
                <Topnav name="WhatsApp HRM" />
                {/* Styled sub-navigation topnav header */}
                <div 
                  className="flex items-center gap-6 px-6 py-3 border-b bg-white" 
                  style={{ minHeight: '60px', boxShadow: '0 2px 4px rgba(0,0,0,0.02)' }}
                >
                  {navLinks.map((link) => {
                    const isActive = activeTab === link.id || location.pathname.startsWith(link.path);
                    return (
                      <button
                        key={link.name}
                        onClick={() => handleNavClick(link.path)}
                        style={{
                          background: 'none',
                          border: 'none',
                          fontWeight: 600,
                          fontSize: '15px',
                          color: isActive ? '#25D366' : '#666',
                          borderBottom: isActive ? '3px solid #25D366' : '3px solid transparent',
                          paddingBottom: '6px',
                          cursor: 'pointer',
                          transition: 'all 0.2s ease-in-out',
                        }}
                      >
                        {link.name}
                      </button>
                    );
                  })}
                </div>
                <div 
                  className={`p-4 ${activeTab === 'inbox' ? 'overflow-hidden' : 'overflow-y-auto'}`} 
                  style={{ 
                    backgroundColor: 'rgb(245,246,250)', 
                    height: 'calc(100vh - 120px)', 
                    display: 'flex', 
                    flexDirection: 'column' 
                  }}
                >
                  <Routes>
                    <Route path="/inbox" element={<InboxView />} />
                    <Route path="/contacts" element={<ContactsView />} />
                    <Route path="/campaigns" element={<CampaignsView />} />
                    <Route path="/campaigns/create" element={<CreateCampaign />} />
                    <Route path="/analytics" element={<AnalyticsView />} />
                    <Route path="/reminder-auto" element={<ReminderAutomation />} />
                    <Route path="/settings" element={<WhatsAppSettings />} />
                    <Route path="/settings/create-template" element={<CreateTemplate />} />
                    <Route path="/*" element={<InboxView />} />
                  </Routes>
                </div>
              </article>
            </main>
            </div>
          </NotificationProvider>
        </ToastProvider>
      </ConfigProvider>
    </WaAuthProvider>
  );
};

export default WhatsAppRouter;


